import React from 'react';

interface ArrowDownProps {
    fill?: string;
}

export const ArrowDown = ({ fill = 'currentColor' }: ArrowDownProps) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1_3494)">
            <path
                d="M8.5 2L7.5 2L7.5155 12.7225L5.3535 10.5615L4.6465 11.2685L6.9395 13.5615C7.22079 13.8427 7.60225 14.0007 8 14.0007C8.39775 14.0007 8.77921 13.8427 9.0605 13.5615L11.3535 11.2685L10.6465 10.5615L8.5155 12.6925L8.5 2Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_1_3494">
                <rect width="12" height="12" fill="white" transform="translate(2 14) rotate(-90)" />
            </clipPath>
        </defs>
    </svg>
);
